import { FieldDescription, FieldError, FieldLabel, fieldIds, fieldInputClass } from './shared';
import type { FieldProps } from './FieldProps';

export function DateField({ field, value, error, onChange }: FieldProps) {
  const { inputId, descriptionId, errorId } = fieldIds(field.path);
  const describedBy = [field.schema.description ? descriptionId : null, error ? errorId : null]
    .filter(Boolean)
    .join(' ');

  return (
    <div>
      <FieldLabel htmlFor={inputId} required={field.required}>
        {field.schema.title ?? field.key}
      </FieldLabel>
      <FieldDescription id={descriptionId} text={field.schema.description} />
      <input
        id={inputId}
        type="date"
        className={fieldInputClass}
        value={typeof value === 'string' ? value : ''}
        onChange={(event) => onChange(event.target.value || undefined)}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
      />
      <FieldError id={errorId} message={error} />
    </div>
  );
}
